import moment from 'moment';
import store from '@/store';

export function localeMoment(date) {
  return moment(date).locale(store.state.locale.locale);
}
